import { Select } from 'components/atoms/Form/Select';
import type { FC } from 'react';
import { ConnectorComponents } from './ConnectorComponents';

interface AccountSelectorProps {
  name: string;
  label: string;
  placeholder: string;
  options: any[];
  value: string | null;
  onChange: (option: any) => void;
}
const AccountSelector: FC<AccountSelectorProps> = ({
  name,
  label,
  placeholder,
  options,
  value,
  onChange,
}) => {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-primary-700 mb-2">
        {label}
      </label>
      <Select
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        components={{
          Option: ConnectorComponents.ConnectorOption,
          SingleValue: ConnectorComponents.ConnectorSingleValue,
        }}
        placeholder={placeholder}
        themeOptions={{
          menuClassName: 'border border-taxes-100 rounded-lg',
          optionClassName: 'hover:bg-taxes-50',
        }}
      />
    </div>
  );
};

export default AccountSelector;
